export default __webpack_public_path__ + "static/media/Mulish-Regular.2f1b7468.ttf";